module.exports = __webpack_public_path__ + "img/bankCheckPreDated.a4e40413.svg";